// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blk-container {
  min-width: 1100px;
  min-height: 500px;
  margin-bottom: 30px;
  box-shadow: 0px 0px 13px rgba(82, 103, 65, 0.16);
  border-radius: 4px;
  margin: auto;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease-in-out;

  .tableBtn {
    background-color: #fff;
    border: 1px solid #2755fe;
    color: #2755fe;
    &:hover {
      background-color: #2755fe;
      color: #fff;
    }
  }

  .tableDelBtn {
    background-color: #fff;
    border: 1px solid #d3455b;
    color: #d3455b;
    &:hover {
      background-color: #e97070;
      color: #fff;
    }
  }

  .blk-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 25px;
    background-color: aliceblue;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
    width: 100%;
    box-sizing: border-box;
    z-index: 10;
    transition: all 0.5s ease-in-out;
    .left {
      display: flex;
      flex-direction: column;
      transition: all 0.5s ease-in-out;
      .msg {
        font-size: 15px;
        font-weight: 500;
        color: #8d8d8d;
        display: flex;
        align-items: center;
      }
    }
    .steps {
      display: flex;
      align-items: center;
      gap: 10px;
      .step {
        font-size: 18px;
        font-weight: 500;
        color: #8d8d8d;
      }
    }
  }

  .blk-step-container {
    display: flex;
    justify-content: center;
    padding: 25px 0px 25px 0px;
    overflow-y: auto;
    flex: 1;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .blk-foot {
    position: fixed;
    bottom: 0;
    left: 0;
    max-width: 1200px;
    width: 100%;
    transform: translate(-50%, 0);
    left: 50%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 80px;
    padding: 0px 20px;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    .cancelButton {
      color: #2755fe;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 24px;
      padding: 8px 16px;
      width: 142px;
      border-radius: 2px;
      margin-right: 16px;
    }

    .cancelButton:hover {
      color: #ffffff;
    }

    .saveButton {
      background-color: #2755fe;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 24px;
      padding: 8px 16px;
      width: 142px;
      border-radius: 2px;
    }
  }

  .step2Container {
    width: 100%;
    padding: 0px 20px;

    .Step2Header {
      width: 100%;
      padding: 0px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;

      .Step2Match {
        font-weight: 500;
      }
    }
    .automatch {
      padding: 0px 20px;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .step2 {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 20px;
    }
  }
  .step3 {
    .step3header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 7px;
    }

    .step3InfoHeader {
      width: 100%;
      display: flex;
      font-size: 15px;
      font-weight: 500;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .showErrorbtn {
        button {
          font-size: 12px !important;
          padding: 4px 8px !important;
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CompanyAdmin/frontend-common/BulkUploader/bulkuploader.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gCAAgC;;EAEhC;IACE,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd;MACE,yBAAyB;MACzB,WAAW;IACb;EACF;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd;MACE,yBAAyB;MACzB,WAAW;IACb;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,gCAAgC;IAChC;MACE,aAAa;MACb,sBAAsB;MACtB,gCAAgC;MAChC;QACE,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,mBAAmB;MACrB;IACF;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT;QACE,eAAe;QACf,gBAAgB;QAChB,cAAc;MAChB;IACF;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,OAAO;IACP,sBAAsB;IACtB,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,4CAA4C;IAC5C,kBAAkB;;IAElB;MACE,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;MACjB,iBAAiB;MACjB,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,yBAAyB;MACzB,cAAc;MACd,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;MACjB,iBAAiB;MACjB,YAAY;MACZ,kBAAkB;IACpB;EACF;;EAEA;IACE,WAAW;IACX,iBAAiB;;IAEjB;MACE,WAAW;MACX,iBAAiB;MACjB,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,mBAAmB;;MAEnB;QACE,gBAAgB;MAClB;IACF;IACA;MACE,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,eAAe;MACf,SAAS;IACX;EACF;EACA;IACE;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,8BAA8B;MAC9B,mBAAmB;MACnB,mBAAmB;MACnB;QACE;UACE,0BAA0B;UAC1B,2BAA2B;QAC7B;MACF;IACF;EACF;AACF","sourcesContent":[".blk-container {\n  min-width: 1100px;\n  min-height: 500px;\n  margin-bottom: 30px;\n  box-shadow: 0px 0px 13px rgba(82, 103, 65, 0.16);\n  border-radius: 4px;\n  margin: auto;\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.5s ease-in-out;\n\n  .tableBtn {\n    background-color: #fff;\n    border: 1px solid #2755fe;\n    color: #2755fe;\n    &:hover {\n      background-color: #2755fe;\n      color: #fff;\n    }\n  }\n\n  .tableDelBtn {\n    background-color: #fff;\n    border: 1px solid #d3455b;\n    color: #d3455b;\n    &:hover {\n      background-color: #e97070;\n      color: #fff;\n    }\n  }\n\n  .blk-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 25px 25px;\n    background-color: aliceblue;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    font-size: 20px;\n    font-weight: 600;\n    color: #333;\n    width: 100%;\n    box-sizing: border-box;\n    z-index: 10;\n    transition: all 0.5s ease-in-out;\n    .left {\n      display: flex;\n      flex-direction: column;\n      transition: all 0.5s ease-in-out;\n      .msg {\n        font-size: 15px;\n        font-weight: 500;\n        color: #8d8d8d;\n        display: flex;\n        align-items: center;\n      }\n    }\n    .steps {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      .step {\n        font-size: 18px;\n        font-weight: 500;\n        color: #8d8d8d;\n      }\n    }\n  }\n\n  .blk-step-container {\n    display: flex;\n    justify-content: center;\n    padding: 25px 0px 25px 0px;\n    overflow-y: auto;\n    flex: 1;\n    box-sizing: border-box;\n    background-color: #fff;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  .blk-foot {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    max-width: 1200px;\n    width: 100%;\n    transform: translate(-50%, 0);\n    left: 50%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #ffffff;\n    height: 80px;\n    padding: 0px 20px;\n    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n\n    .cancelButton {\n      color: #2755fe;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 24px;\n      padding: 8px 16px;\n      width: 142px;\n      border-radius: 2px;\n      margin-right: 16px;\n    }\n\n    .cancelButton:hover {\n      color: #ffffff;\n    }\n\n    .saveButton {\n      background-color: #2755fe;\n      color: #ffffff;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: 0;\n      line-height: 24px;\n      padding: 8px 16px;\n      width: 142px;\n      border-radius: 2px;\n    }\n  }\n\n  .step2Container {\n    width: 100%;\n    padding: 0px 20px;\n\n    .Step2Header {\n      width: 100%;\n      padding: 0px 20px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 30px;\n\n      .Step2Match {\n        font-weight: 500;\n      }\n    }\n    .automatch {\n      padding: 0px 20px;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n\n    .step2 {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      flex-wrap: wrap;\n      gap: 20px;\n    }\n  }\n  .step3 {\n    .step3header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 7px;\n    }\n\n    .step3InfoHeader {\n      width: 100%;\n      display: flex;\n      font-size: 15px;\n      font-weight: 500;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 10px;\n      .showErrorbtn {\n        button {\n          font-size: 12px !important;\n          padding: 4px 8px !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
